export class HttpError extends Error {
  readonly status: number;
  readonly body: ErrorBody | undefined;

  constructor(response: Response, body: ErrorBody | undefined) {
    super(`HTTP ${response.status}`);
    this.name = 'HttpError';
    this.status = response.status;
    this.body = body;
  }

  hasErrorCode(code: string): boolean {
    return this.body?.errors.some((error) => error.code === code) ?? false;
  }

  static async from(response: Response): Promise<HttpError> {
    const body = await response.json().catch(() => undefined);
    return new HttpError(response, body);
  }
}

export function isHttpError(error: unknown): error is HttpError {
  return error instanceof HttpError;
}

export type ErrorBody = {
  errors: ErrorCode[];
  message: string;
  status: number;
  ts: string;
};

export type ErrorCode = {
  code: string;
};
